import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import api from './api-client'

export type DatasourcesStatus = 'idle' | 'loading' | 'success' | 'error'

type DatasourcesState = {
  map: Record<string, unknown>
  status: DatasourcesStatus
  error: string
}

const initialState: DatasourcesState = {
  map: {},
  status: 'idle',
  error: '',
}

export const fetchDatasources = createAsyncThunk<any, void, {rejectValue: string}>('datasources', async (data, _api) => {
  try {
    const map = {}
    const datasources = await api.getDatasources()
    datasources.forEach(d => {
      map[d._id] = d
    })
    return map
  } catch (err) {
    return _api.rejectWithValue(err.message || err.msg)
  }
})

const slice = createSlice({
  name: 'datasources',
  initialState,
  reducers: { },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDatasources.pending, (state) => {
        state.status = 'loading'
        state.error = ''
      })
      .addCase(fetchDatasources.fulfilled, (state, action) => {
        state.map = action.payload
        state.status = 'success'
      })
      .addCase(fetchDatasources.rejected, (state, action) => {
        state.status = 'error'
        state.error = action.payload || 'Failed to fetch datasources'
      })
  }
})

export default slice.reducer
